export enum LicenseType {
    Light = 0,
    Standard = 1, 
    VR = 2,
    Workspace = 3
}